import * as PIXI from 'pixi.js'

import Borders, { Sides } from './Borders'

export default class GraphicsDrawer {
  constructor() {
    this.graphics = new PIXI.Graphics()
  }

  getElement() {
    return this.graphics
  }

  draw(style, width, height) {
    const { graphics } = this
    const borders = new Borders(style, width, height)
    const isSameBordersAppearance = borders.isSameAppearance()

    graphics.clear()

    if (style.backgroundColor != null) {
      graphics.beginFill(parseColor(style.backgroundColor))
    }

    if (isSameBordersAppearance) {
      const width = borders.getWidth(0)
      if (width) {
        graphics.lineStyle(width, parseColor(borders.Color[0]), 1, 0)
      }
    }

    if (borders.isSameRadius()) {
      const radius = borders.Radius[0] || 0
      if (radius === 0) {
        graphics.drawRect(0, 0, width, height)
      } else {
        graphics.drawRoundedRect(0, 0, width, height, radius)
      }
    } else {
      const [rTL, rTR, rBR, rBL] = borders.Radius
      graphics.moveTo(0 + rTL, 0)
      graphics.lineTo(width - rTR, 0)
      if (rTR) {
        graphics.quadraticCurveTo(width, 0, width, rTR)
      }
      graphics.lineTo(width, height - rBR)
      if (rBR) {
        graphics.quadraticCurveTo(width, height, width - rBR, height)
      }
      graphics.lineTo(rBL, height)
      if (rBL) {
        graphics.quadraticCurveTo(0, height, 0, height - rBL)
      }
      graphics.lineTo(0, rTL)
      if (rTL) {
        graphics.quadraticCurveTo(0, 0, rTL, 0)
      }
    }

    if (style.backgroundColor != null) {
      graphics.endFill()
    }

    if (!isSameBordersAppearance) {
      for (let i = 0; i < 4; i++) {
        const points = borders.getPoints(Sides[i])
        // console.log(Sides[i], points)
        if (Array.isArray(points)) {
          graphics.beginFill(parseColor(borders.Color[i]))
          graphics.drawPolygon(points)
          graphics.endFill()
        }
      }
    }
  }

  destroy() {
    if (!this.graphics._destroyed) {
      this.graphics.destroy()
    }
  }
}

function parseColor(color) {
  if (color.indexOf('#') === 0) {
    return color.replace('#', '0x') * 1
  }
}
